// Vendor
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// House
import { ApiService } from './api.service';

export enum AccountStatus {
  'ACTIVE' = 'active',
  'PAST_DUE' = 'past_due',
  'CANCELLED' = 'cancelled',
  'INACTIVE' = 'inactive',
  'DEMO' = 'demo',
  'TRIAL' = 'trial',
}

export class AccountModel {
  hyperline_auth_token :string;
  hyperline_customer_id :string;
  hyperline_estimated_arr :string;
  hyperline_last_invoice_date :string;
  hyperline_subscription_status :string;
  hyperline_total_past_due :string;
  id :string;
  luminous_account_status :AccountStatus;
}

@Injectable({
  providedIn: 'root',
})
export class AccountApiService {
  basePath :string = `${this.api.environment.urlV2}/account`;

  constructor(private api :ApiService) {}

  get() :Observable<AccountModel> {
    return this.api.get(`${this.basePath}`);
  }
}
